/**
 * 移除url中的某个字段
 * @param url
 * @param field
 * @returns
 */
export function removeUrlQuery(url: string, field: string): string {
  let reg;
  let queryString;
  if (field) {
    reg = new RegExp(`[?&]?${field}=([^&#]*)`, 'i');
    try {
      [queryString] = reg.exec(url);
    } catch (e) {
      queryString = '';
    }
  }
  if (queryString !== '') {
    // eslint-disable-next-line no-param-reassign
    url = url.replace(queryString, '');
  }
  return url;
};

/**
 * 替换url中的某个字段的值
 * @param url
 * @param field
 * @param value
 * @returns
 */
export function replaceUrlQuery(url: string, field: string, value: string): string {
  let reg;
  let queryString;
  if (field) {
    reg = new RegExp(`([?&]?)${field}=([^&#]*)`, 'i');
    try {
      queryString = reg.exec(url);
    } catch (e) {
      queryString = '';
    }
  }
  if (queryString) {
    // eslint-disable-next-line no-param-reassign
    url = url.replace(`${field}=${queryString[2]}`, `${field}=${value}`);
  }
  return url;
};

/**
 * 为url添加新参数
 * @param url
 * @param field
 * @param value
 */
export function addUrlQuery(url: string, field: string, value: string) {
  return `${url + (url.indexOf('?') > -1 ? '&' : '?') + field}=${encodeURIComponent(value)}`;
}
